import { render, staticRenderFns } from "./AnnualizationMain.vue?vue&type=template&id=638da7dc"
import script from "./AnnualizationMain.vue?vue&type=script&lang=js"
export * from "./AnnualizationMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports